export default "__VITE_ASSET__504b7443__"